import { render, staticRenderFns } from "./inspectFormDialog.vue?vue&type=template&id=f85d8136&scoped=true&"
import script from "./inspectFormDialog.vue?vue&type=script&lang=js&"
export * from "./inspectFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85d8136",
  null
  
)

export default component.exports